import { InitPage } from "../index";
import { ImportFile } from "../common/import_file";
import ScreenSaver from "../controls/screen_saver";

class Eaa {
  constructor() {
    InitPage("index", () => {
      new ImportFile();
    });

    InitPage("show", () => {
      new ScreenSaver();
    });
  }
}

export function LoadPage() {
  InitPage("eaas", () => {
    new Eaa();
  });
}
